import React, { useState, useEffect } from "react";
import GalleryService from "../../services/GalleryService";

import { motion } from "motion/react";
const GalleryList = () => {
  const [Gallery, setGallery] = useState([]);
  //const [currentGallery, setCurrentGallery] = useState(null);
  //const [currentIndex, setCurrentIndex] = useState(-1);
  //const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
    retrieveGallery();
  }, []);

  const retrieveGallery = () => {
    GalleryService.getAll()
      .then((response) => {
        setGallery(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // const setActiveGallery = (Gallery, index) => {
  //   setCurrentGallery(Gallery);
  //   setCurrentIndex(index);
  // };

  // const refreshList = () => {
  //   retrieveGallery();
  //   // setCurrentGallery(null);
  //   // setCurrentIndex(-1);
  // };

  // console.log("Current Gallery:"+JSON.stringify(currentGallery))

  return (
    <>
      <div className="pb-10  bg-slate-100 w-full">
        <div className="flex flex-row-2 w-full h-16 text-center relative gap-y-80">
          <h1 className="text-4xl lg:text-4xl font-semibold px-10 pt-10">
            {" "}
            Gallerys Medias
          </h1>

          <button
            className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700
      hover:border-blue-500 rounded  absolute top-10 right-0"
          >
            <a
              href={"/admin/gallery/add"}
              className="lg:text-1xl"
            >
              Add New Gallery Media
            </a>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-8">
          {Gallery &&
            Gallery.map((menuitem, index) => (
              <div
                className="m-2 bg-white rounded-lg bg-contain "
                key={index}
                style={{
                  backgroundImage: `url(${menuitem.image})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  justifyContent: "center",
                  backgroundPosition: "center",
                }}
              >
                <motion.div
                  initial={{ x: 100, opacity: 0 }}
                  viewport={{ once: true }}
                  whileInView={{
                    x: 0,
                    opacity: 1,
                    transition: {
                      delay: 0.5,
                      x: { type: "spring", stiffness: 60 },
                      opacity: { duration: 0.6 },
                      ease: "easeIn",
                    },
                  }}
                  className=""
                >
                  <div className="flex flex-row-2 gap-8  p-6 w-full overflow-ellipsis">
                    <a
                      href={"/admin/gallery/" + menuitem.id}
                      className="ml-auto"
                    >
                      <button className="bg-white hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                        Edit
                      </button>
                    </a>
                  </div>

                  <p className="flex justify-center sm:px-12 p-8 h-[150px]">
                    {/* <img className="object-cover justify-center items-center w-full" src={menuitem.image} alt=""/> */}
                  </p>
                </motion.div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default GalleryList;
